import {
	CompanyNode,
	OtherNode,
	PartnershipNode,
	TrustNode,
} from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Nodes';
import {
	DebtEdge,
	EquityEdge,
	FastEquityEdge,
} from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Edges';
import { Edge, Node } from '@dealstack/shared/lib/generated';
import { Position } from '@xyflow/react';
import type { CAP_TABLE_VALUES_HELD_TYPE } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableSettings.ts';

export enum NodeTypes {
	PARTNERSHIP = 'partnership',
	COMPANY = 'company',
	OTHER = 'other',
	TRUST = 'trust',
}

export enum EdgeTypes {
	EQUITY = 'equity',
	DEBT = 'debt',
}

export const nodeTypes = {
	[NodeTypes.PARTNERSHIP]: PartnershipNode,
	[NodeTypes.COMPANY]: CompanyNode,
	[NodeTypes.OTHER]: OtherNode,
	[NodeTypes.TRUST]: TrustNode,
};

export const edgeTypes = {
	[EdgeTypes.DEBT]: DebtEdge,
	[EdgeTypes.EQUITY]: EquityEdge,
};

export const edgeTypesFast = {
	[EdgeTypes.DEBT]: DebtEdge,
	[EdgeTypes.EQUITY]: FastEquityEdge,
};

export type NodeLoanData = {
	source: boolean;
	target: boolean;
	sourcePosition?: Position | null;
};

export type NodeData = {
	label: string;
	registeredId?: string;
	isMipGroup: boolean;
	registeredName?: string;
	countryCode?: string;
	loanData?: NodeLoanData;
};

export type NodeRes = Node;
export type EdgeRes = Edge;

export type CapChartEdgeLabelValue = {
	valuesHeldType: CAP_TABLE_VALUES_HELD_TYPE;
	text: string;
};

export type CapChartEdgeData = EdgeRes & {
	/** Pre-formatted for the current chart settings; empty when the edge shows no label. */
	labelValues: CapChartEdgeLabelValue[];
};
